module.exports = __webpack_public_path__ + "media/images/golden_pin_concept_design_award_icon-168249b66ff377a8d2901cd5f0d99c2d.png";